<script>
import {BTbody} from "bootstrap-vue";

export default {
  extends: BTbody
};
</script>